import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TablePros {
    [tableName: string]: string[];
}

interface TableColumnsContext {
    displayColumns: TablePros;
    setDisplayColumns: (value: TablePros) => void;
}

const initialTableColumnsContextValue: TableColumnsContext = {
    displayColumns: {},
    setDisplayColumns: () => {},
};

const TableColumnsContext = createContext<TableColumnsContext>(initialTableColumnsContextValue);
export const useTableColumnsContext = () => useContext(TableColumnsContext);

interface Props {
    children: ReactNode;
}

const TableColumnsContextProvider = ({ children }: Props) => {
    const [displayColumns, setDisplayColumns] = useState({});

    return (
        <TableColumnsContext.Provider value={{ displayColumns, setDisplayColumns }}>
            {children}
        </TableColumnsContext.Provider>
    );
};

export default TableColumnsContextProvider;
